// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca, catálogo e o
// carregador das telas. Outro módulo usa a `public.ts` (A06).
export {
  TENANT_PERMISSION_RESOURCE_PATH,
  tenantPermissionResourceFormScreen,
  tenantPermissionResourceListScreen,
} from './tenant-permission-resource.screen';
export {
  tenantPermissionResourceFormSearch,
  tenantPermissionResourceListSearch,
} from './tenant-permission-resource.search';
export { loadTenantPermissionResourceMessages } from './tenant-permission-resource.catalog';

/** As telas (`TenantPermissionResourceListPage`, `TenantPermissionResourceFormPage`), por `lazyScreen`. */
export const loadTenantPermissionResourceScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadTenantPermissionResourceGuides = () => import('./tenant-permission-resource.guide');
